import { css } from '@emotion/react'
import { notificationApi } from '@mathflat/domain/Notification'
import { s3URL } from '@mathflat/shared/@common/utils/s3'
import clsx from 'clsx'

import { useStudentAppMediaQuery } from '~/@common/hooks/useMediaQuery'
import { webviewService } from '~/@common/services'
import modalService from '~/@common/services/modal.service'
import { typo } from '~/@common/styles'
import Button from '~/@common/ui/(Button)/Button/Button'

const PushNotificationPermissionModal = () => {
  const { isMobile } = useStudentAppMediaQuery()

  const handlePermission = async (isAgreed: boolean) => {
    await notificationApi.updatePushNotificationSetting({ pushEnabled: isAgreed })

    if (isAgreed) {
      // 앱 내 시스템 알림 설정 요청
      webviewService.revalidatePermission()
    }

    if (!isAgreed) {
      const deniedAt = new Date().toISOString()
      localStorage.setItem('pushNotificationDeniedTimestamp', deniedAt)
    }

    modalService.closeModal()
  }

  return (
    <div css={S.Container} className={clsx(isMobile && 'mobile')}>
      <header>
        학습에 도움되는 알림을 받기 위해&nbsp;
        {isMobile && <br />}
        동의가 필요해요
      </header>
      <div className="content">
        <div className="title">해야하는 학습을 놓치지 않아요!</div>
        <img
          src={s3URL.student('images/student_push_notification_permission.png')}
          alt="학습에 도움되는 알림을 받기 위해 동의가 필요해요"
        />
        {isMobile ? (
          <div className="description">
            <strong>마이 페이지</strong>에서 설정할 수 있어요.
          </div>
        ) : (
          <div className="description">
            푸시 알림 설정은 <strong>마이 페이지</strong>에서 설정할 수 있어요.
          </div>
        )}
      </div>
      <footer>
        <Button theme="primary" size="large" minWidth="100%" onClick={() => handlePermission(true)}>
          동의하고 알림받기
        </Button>
        <div className="next" onClick={() => handlePermission(false)}>
          다음에 할게요
        </div>
      </footer>
    </div>
  )
}

export default PushNotificationPermissionModal

const S = {
  Container: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 444px;
    gap: 20px;

    &.mobile {
      width: 312px;
    }

    > header {
      ${typo.body01};
      font-weight: 700;
      color: var(--Colors-Gray-900);
      text-align: center;
    }

    > .content {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: center;
      align-items: center;
      padding: 20px;
      gap: 16px;
      border-radius: var(--Radius-300);
      background: var(--Colors-Gray-100);

      .title {
        ${typo.caption01};
        color: var(--Colors-Blue-600);
        text-align: center;
        font-weight: 700;
      }

      .description {
        ${typo.caption01};
        padding: 12px;
        width: 100%;
        color: var(--Colors-Gray-600);
        border-radius: var(--Radius-200);
        background: var(--White);
        text-align: center;
      }

      img {
        width: 100%;
      }
    }

    > footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      gap: 10px;

      .next {
        ${typo.caption01};
        color: var(--Colors-Gray-700);
        text-decoration: underline;
        cursor: pointer;
      }
    }
  `,
}
